import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackAuthenticateClick, trackPlaceOfferClick } from './tracking';
import { modalOpen } from '../../actions/authentication';
import { UserRelated } from '../../components/UserRelated';
import { useMenuEnabled } from '../../hooks/useMenuEnabled';
import { selectPageType } from '../../selectors/page';
import { selectHasSpecialPromo } from '../../selectors/specialPromos';
import { selectShouldShowNewPlacementText, selectUser } from '../../selectors/user';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { TUserState } from '../../types/user';
import { useApplicationContext } from '../../utils/applicationContext';
import { CianGptButtonContainer } from '../CianGptButtonContainer';
import { SpecialPromosDesktopContainer } from '../SpecialPromosDesktopContainer/SpecialPromosDesktopContainer';
import { UserContainer } from '../UserContainer';
import { UtilitiesContainer as UtilitiesContainerRedesign } from '../UtilitiesContainer/Redesign';

export const UserRelatedContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();
  const user = useSelector<IApplicationState, TUserState>(selectUser);
  const hasBlockedSanction = user.isAuthenticated ? user.hasBlockedSanction : false;
  const hasSpecialPromo = useSelector(selectHasSpecialPromo);
  const pageType = useSelector(selectPageType);
  const placeOfferLink = useSelector<IApplicationState, string | null>(state => state.servicesLinks.placeOffer);
  const shouldShowNewPlacementText = useSelector(selectShouldShowNewPlacementText);

  const isMenuEnabled = useMenuEnabled();
  const isCianGptButtonEnabled = config.get<boolean>('header-frontend.cianGptButton.Enabled') ?? false;

  const handlePlaceOfferClick = React.useCallback(() => trackPlaceOfferClick(pageType), [pageType]);
  const handleAuthenticateClick = React.useCallback(() => {
    dispatch(modalOpen());
    trackAuthenticateClick(pageType);
  }, [dispatch, pageType]);

  const specialPromo = React.useMemo(
    () => (hasSpecialPromo && isMenuEnabled ? <SpecialPromosDesktopContainer /> : null),
    [hasSpecialPromo, isMenuEnabled],
  );

  return (
    <UserRelated
      gptButton={isCianGptButtonEnabled ? <CianGptButtonContainer /> : null}
      userMenu={user.isAuthenticated ? <UserContainer /> : null}
      utilities={<UtilitiesContainerRedesign />}
      placeOfferLink={placeOfferLink}
      hasBlockedSanction={hasBlockedSanction}
      specialPromo={specialPromo}
      shouldShowNewPlacementText={shouldShowNewPlacementText}
      onPlaceOfferClick={handlePlaceOfferClick}
      onAuthenticateClick={handleAuthenticateClick}
    />
  );
};
